import { render, staticRenderFns } from "./GetInfoCentersCompetenceChatGPT.vue?vue&type=template&id=50650bbe&scoped=true"
import script from "./GetInfoCentersCompetenceChatGPT.vue?vue&type=script&lang=js"
export * from "./GetInfoCentersCompetenceChatGPT.vue?vue&type=script&lang=js"
import style0 from "./GetInfoCentersCompetenceChatGPT.vue?vue&type=style&index=0&id=50650bbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50650bbe",
  null
  
)

export default component.exports